import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { listAgents, getAgent, deleteAgent, getLatestAgentVersion, updateAgent } from '@/api/agents';

export function useAgents() {
  return useQuery({
    queryKey: ['agents'],
    queryFn: () => listAgents(),
    refetchInterval: 10_000, // agents go on/offline; keep the list fresh
  });
}

export function useAgent(id: string | undefined) {
  return useQuery({
    queryKey: ['agent', id],
    queryFn: () => getAgent(id!),
    enabled: !!id,
  });
}

export function useDeleteAgent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteAgent(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['agents'] }),
  });
}

export function useLatestAgentVersion() {
  return useQuery({
    queryKey: ['agents', 'latest-version'],
    queryFn: () => getLatestAgentVersion(),
    staleTime: 60_000,
  });
}

export function useUpdateAgent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => updateAgent(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['agents'] }),
  });
}
